(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/constant"), require("@splat/input"), require("@splat/select"), require("@splat/theme"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"), require("core-js/modules/esnext.global-this.js"), require("vuex"), require("vuex-class"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , , , , , "core-js/modules/esnext.global-this.js", , ], factory);
	else if(typeof exports === 'object')
		exports["pagination"] = factory(require("@splat/constant"), require("@splat/input"), require("@splat/select"), require("@splat/theme"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"), require("core-js/modules/esnext.global-this.js"), require("vuex"), require("vuex-class"));
	else
		root["pagination"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root["core-js/modules/esnext.global-this.js"], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE__splat_input__, __WEBPACK_EXTERNAL_MODULE__splat_select__, __WEBPACK_EXTERNAL_MODULE__splat_theme__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__, __WEBPACK_EXTERNAL_MODULE_vuex__, __WEBPACK_EXTERNAL_MODULE_vuex_class__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/item.tsx":
/*!**********************!*\
  !*** ./src/item.tsx ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var paginationItemClass = function paginationItemClass(type) {
  return (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('pagination-item', type);
};

var PaginationItem = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(PaginationItem, _tsx$Component);

  var _super = _createSuper(PaginationItem);

  function PaginationItem() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, PaginationItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "index", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "selected", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabled", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "border", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "styleType", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(PaginationItem, [{
    key: "onClick",
    value: function onClick() {
      return this.index;
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var styleType = this.styleType,
          selected = this.selected,
          disabled = this.disabled,
          border = this.border,
          onClick = this.onClick;
      return h("button", {
        "attrs": {
          "disabled": disabled,
          "type": 'button'
        },
        "on": {
          "click": onClick
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(styleType === _types__WEBPACK_IMPORTED_MODULE_11__.PaginationStyleType.Normal && _style__WEBPACK_IMPORTED_MODULE_10__.paginationItemNormalClassName(this.theme), styleType === _types__WEBPACK_IMPORTED_MODULE_11__.PaginationStyleType.Normal && paginationItemClass('normal'), styleType === _types__WEBPACK_IMPORTED_MODULE_11__.PaginationStyleType.Large && _style__WEBPACK_IMPORTED_MODULE_10__.paginationItemLargeClassName(this.theme), styleType === _types__WEBPACK_IMPORTED_MODULE_11__.PaginationStyleType.Large && paginationItemClass('large'), border ? _style__WEBPACK_IMPORTED_MODULE_10__.paginationItemBorderClassName : _style__WEBPACK_IMPORTED_MODULE_10__.paginationItemNoBorderClassName, border && paginationItemClass('border'), selected && (border ? _style__WEBPACK_IMPORTED_MODULE_10__.paginationHighlightClassName(this.theme) : _style__WEBPACK_IMPORTED_MODULE_10__.paginationHighlightWithoutBorderClassName(this.theme)), selected && (border ? paginationItemClass('selected') : paginationItemClass('selected-without-border')), disabled && _style__WEBPACK_IMPORTED_MODULE_10__.paginationDisabledItemClassName, disabled && paginationItemClass('disabled'))
      }, [this.$slots.default]);
    }
  }]);

  return PaginationItem;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], PaginationItem.prototype, "index", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: false
})], PaginationItem.prototype, "selected", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: false
})], PaginationItem.prototype, "disabled", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: true
})], PaginationItem.prototype, "border", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: _types__WEBPACK_IMPORTED_MODULE_11__.PaginationStyleType.Large
})], PaginationItem.prototype, "styleType", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Emit)('click')], PaginationItem.prototype, "onClick", null);

PaginationItem = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_9___default())]
})], PaginationItem);
/* harmony default export */ __webpack_exports__["default"] = (PaginationItem);

/***/ }),

/***/ "./src/locales/index.ts":
/*!******************************!*\
  !*** ./src/locales/index.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I18nProvider": function() { return /* binding */ I18nProvider; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/esnext.global-this.js */ "core-js/modules/esnext.global-this.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__);




var I18nProvider = /*#__PURE__*/function () {
  function I18nProvider(maps, _lang, fallback) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, I18nProvider);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "maps", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "_lang", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "fallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "subs", new Set());

    this.maps = maps;
    this._lang = _lang;
    this.fallback = fallback;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(I18nProvider, [{
    key: "lang",
    get: function get() {
      return this._lang;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      if (this._lang === lang) return;
      this._lang = lang;
      this.subs.forEach(function (x) {
        return x(lang);
      });
    }
  }, {
    key: "addSub",
    value: function addSub(cb) {
      this.subs.add(cb);
    }
  }, {
    key: "removeSub",
    value: function removeSub(cb) {
      this.subs.delete(cb);
    }
  }, {
    key: "t",
    get: function get() {
      return this.maps[this.lang] || this.maps[this.fallback];
    }
  }]);

  return I18nProvider;
}();
var provider = new I18nProvider({
  'en-US': {
    pagination: {
      prePage: 'Per Page',
      goto: 'Goto',
      page: 'Page',
      total: 'Total',
      item: 'Item'
    }
  },
  'zh-CHT': {
    pagination: {
      prePage: "\u689D / \u9801",
      goto: "\u8DF3\u81F3",
      page: "\u9801",
      total: "\u5171",
      item: "\u689D"
    }
  },
  'zh-CN': {
    pagination: {
      prePage: "\u6761 / \u9875",
      goto: "\u8DF3\u81F3",
      page: "\u9875",
      total: "\u5171",
      item: "\u6761"
    }
  }
}, globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN', globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN');
/* harmony default export */ __webpack_exports__["default"] = (provider);

/***/ }),

/***/ "./src/pagination.tsx":
/*!****************************!*\
  !*** ./src/pagination.tsx ***!
  \****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/input */ "@splat/input");
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_input__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _splat_select__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @splat/select */ "@splat/select");
/* harmony import */ var _splat_select__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_splat_select__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _item__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./item */ "./src/item.tsx");
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./locales */ "./src/locales/index.ts");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_19__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};














var PaginationContainer = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(PaginationContainer, _tsx$Component);

  var _super = _createSuper(PaginationContainer);

  function PaginationContainer() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, PaginationContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "page", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "total", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "customTotal", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "totalPages", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "size", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "sizes", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "light", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "border", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "pageToShow", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "showJumper", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "showTotal", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "safeJumper", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "styleType", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18n", _locales__WEBPACK_IMPORTED_MODULE_13__["default"]);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nInjection", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nProvider", _this.i18n);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(PaginationContainer, [{
    key: "pages",
    get: function get() {
      var total = this.total,
          totalPages = this.totalPages,
          size = this.size,
          page = this.page;

      var _pages = totalPages || Math.ceil(total / size);

      if (_pages && _pages < page) this.onPageChanged(_pages);
      return _pages;
    }
  }, {
    key: "hasMorePage",
    get: function get() {
      var pages = this.pages,
          pageToShow = this.pageToShow;
      return pages > pageToShow;
    }
  }, {
    key: "currentPages",
    get: function get() {
      var page = this.page,
          pages = this.pages,
          hasMorePage = this.hasMorePage;

      if (!hasMorePage) {
        return (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.range)(1, pages + 1);
      }

      switch (page) {
        case 1:
        case 2:
          return (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.range)(1, 5 + 1);

        case pages - 1:
        case pages:
          return (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.range)(pages - 4, pages + 1);

        default:
          return (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.range)(page - 2, page + 3);
      }
    }
  }, {
    key: "hasPrev",
    get: function get() {
      var page = this.page;
      return page > 1;
    }
  }, {
    key: "hasNext",
    get: function get() {
      var page = this.page,
          pages = this.pages;
      return page < pages;
    }
  }, {
    key: "onSizeChanged",
    value: function onSizeChanged(v) {
      return v;
    }
  }, {
    key: "onPageChanged",
    value: function onPageChanged(v) {
      return v;
    }
  }, {
    key: "handlePageChanged",
    value: function handlePageChanged(v) {
      var page = parseInt(v, 10);

      if (isNaN(page) || !page) {
        return;
      }

      this.onPageChanged(this.safeJumper ? (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.clamp)(page, 1, this.pages) : page);
    }
  }, {
    key: "handlePrev",
    value: function handlePrev() {
      var page = this.page,
          pages = this.pages,
          onPageChanged = this.onPageChanged;
      onPageChanged((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.clamp)(page - 1, 1, pages));
    }
  }, {
    key: "handleNext",
    value: function handleNext() {
      var page = this.page,
          pages = this.pages,
          onPageChanged = this.onPageChanged;
      onPageChanged((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.clamp)(page + 1, 1, pages));
    }
  }, {
    key: "renderLight",
    value: function renderLight() {
      var h = this.$createElement;
      var page = this.page,
          hasNext = this.hasNext,
          hasPrev = this.hasPrev,
          currentPages = this.currentPages,
          border = this.border,
          handlePrev = this.handlePrev,
          handleNext = this.handleNext,
          onPageChanged = this.onPageChanged,
          showJumper = this.showJumper,
          handlePageChanged = this.handlePageChanged,
          pages = this.pages,
          light = this.light,
          styleType = this.styleType;
      return h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_14__.paginationContainerContentClassName, border && _style__WEBPACK_IMPORTED_MODULE_14__.paginationBorderFontClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('pagination-light'))
      }, [h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
        "attrs": {
          "border": border,
          "disabled": !hasPrev,
          "styleType": styleType
        },
        "on": {
          "click": handlePrev
        }
      }, ['<']), showJumper ? [h((_splat_input__WEBPACK_IMPORTED_MODULE_9___default()), {
        "attrs": {
          "type": 'number',
          "value": page.toString()
        },
        "on": {
          "change": handlePageChanged
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(styleType === _types__WEBPACK_IMPORTED_MODULE_15__.PaginationStyleType.Normal && _style__WEBPACK_IMPORTED_MODULE_14__.paginationInputNormalClassName, styleType === _types__WEBPACK_IMPORTED_MODULE_15__.PaginationStyleType.Large && _style__WEBPACK_IMPORTED_MODULE_14__.paginationInputLargeClassName, _style__WEBPACK_IMPORTED_MODULE_14__.paginationInputContainerClassName(this.theme), border && light && _style__WEBPACK_IMPORTED_MODULE_14__.paginationInputHeightClassName)
      }), h("span", ["/"]), h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
        "attrs": {
          "border": border,
          "selected": page === pages,
          "index": pages,
          "styleType": styleType
        },
        "on": {
          "click": onPageChanged
        }
      }, [pages])] : currentPages.map(function (x) {
        return h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
          "attrs": {
            "border": border,
            "selected": page === x,
            "index": x,
            "styleType": styleType
          },
          "on": {
            "click": onPageChanged
          }
        }, [x]);
      }), h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
        "attrs": {
          "border": border,
          "disabled": !hasNext,
          "styleType": styleType
        },
        "on": {
          "click": handleNext
        }
      }, ['>'])]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var h = arguments[0];
      var light = this.light,
          total = this.total,
          customTotal = this.customTotal,
          page = this.page,
          size = this.size,
          sizes = this.sizes,
          hasNext = this.hasNext,
          hasPrev = this.hasPrev,
          border = this.border,
          showJumper = this.showJumper,
          showTotal = this.showTotal,
          renderLight = this.renderLight,
          currentPages = this.currentPages,
          onSizeChanged = this.onSizeChanged,
          onPageChanged = this.onPageChanged,
          handlePageChanged = this.handlePageChanged,
          handlePrev = this.handlePrev,
          handleNext = this.handleNext,
          pages = this.pages,
          styleType = this.styleType;
      return light ? renderLight() : h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(styleType === _types__WEBPACK_IMPORTED_MODULE_15__.PaginationStyleType.Normal && _style__WEBPACK_IMPORTED_MODULE_14__.paginationContainerNormalClassname, styleType === _types__WEBPACK_IMPORTED_MODULE_15__.PaginationStyleType.Large && _style__WEBPACK_IMPORTED_MODULE_14__.paginationContainerLargeClassname, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('pagination'))
      }, [showTotal && total !== undefined ? h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_14__.paginationTotalClassName, border && _style__WEBPACK_IMPORTED_MODULE_14__.paginationBorderFontClassName)
      }, ["".concat(this.i18n.t.pagination.total, " ").concat(customTotal || total, " ").concat(this.i18n.t.pagination.item)]) : null, h((_splat_select__WEBPACK_IMPORTED_MODULE_10___default()), {
        "attrs": {
          "direction": _splat_select__WEBPACK_IMPORTED_MODULE_10__.Direction.leftUp,
          "value": size,
          "options": sizes.map(function (s) {
            return {
              label: "".concat(s, " ").concat(_this2.i18n.t.pagination.prePage),
              value: s
            };
          })
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(styleType === _types__WEBPACK_IMPORTED_MODULE_15__.PaginationStyleType.Normal && _style__WEBPACK_IMPORTED_MODULE_14__.paginationSelectNormalClassName, styleType === _types__WEBPACK_IMPORTED_MODULE_15__.PaginationStyleType.Large && _style__WEBPACK_IMPORTED_MODULE_14__.paginationSelectLargeClassName, border && _style__WEBPACK_IMPORTED_MODULE_14__.paginationBorderFontClassName),
        "on": {
          "input": function input(v) {
            return onSizeChanged(v);
          }
        }
      }), h("span", {
        "class": _style__WEBPACK_IMPORTED_MODULE_14__.paginationContainerContentClassName
      }, [h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
        "attrs": {
          "border": border,
          "disabled": !hasPrev,
          "styleType": styleType
        },
        "on": {
          "click": handlePrev
        }
      }, ['<']), currentPages.includes(1) ? null : [h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
        "attrs": {
          "border": border,
          "selected": false,
          "index": 1,
          "styleType": styleType
        },
        "on": {
          "click": onPageChanged
        }
      }, ["1"]), currentPages.includes(2) ? null : h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
        "attrs": {
          "border": border,
          "selected": false,
          "index": (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.clamp)(page - 5, 1, pages),
          "styleType": styleType
        },
        "on": {
          "click": onPageChanged
        },
        "class": _style__WEBPACK_IMPORTED_MODULE_14__.paginationQuickPrevButtonClassName
      }, [h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)('el-icon', 'more', 'btn-quickprev', 'el-icon-more')
      })])], currentPages.map(function (x) {
        return h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
          "attrs": {
            "border": border,
            "selected": page === x,
            "index": x,
            "styleType": styleType
          },
          "on": {
            "click": onPageChanged
          }
        }, [x]);
      }), currentPages.includes(pages) ? null : [currentPages.includes(pages - 1) ? null : h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
        "attrs": {
          "border": border,
          "selected": false,
          "index": (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.clamp)(page + 5, 1, pages),
          "styleType": styleType
        },
        "on": {
          "click": onPageChanged
        },
        "class": _style__WEBPACK_IMPORTED_MODULE_14__.paginationQuickNextButtonClassName
      }, [h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)('el-icon', 'more', 'btn-quicknext', 'el-icon-more')
      })]), h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
        "attrs": {
          "border": border,
          "selected": false,
          "index": pages,
          "styleType": styleType
        },
        "on": {
          "click": onPageChanged
        }
      }, [pages])], h(_item__WEBPACK_IMPORTED_MODULE_12__["default"], {
        "attrs": {
          "border": border,
          "disabled": !hasNext,
          "styleType": styleType
        },
        "on": {
          "click": handleNext
        }
      }, ['>'])]), showJumper ? h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(_style__WEBPACK_IMPORTED_MODULE_14__.paginationJumperClassName, border && _style__WEBPACK_IMPORTED_MODULE_14__.paginationBorderFontClassName)
      }, [h("span", [this.i18n.t.pagination.goto]), h((_splat_input__WEBPACK_IMPORTED_MODULE_9___default()), {
        "attrs": {
          "type": 'number',
          "value": page.toString()
        },
        "on": {
          "change": handlePageChanged
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_19__.classes)(styleType === _types__WEBPACK_IMPORTED_MODULE_15__.PaginationStyleType.Normal && _style__WEBPACK_IMPORTED_MODULE_14__.paginationInputNormalClassName, styleType === _types__WEBPACK_IMPORTED_MODULE_15__.PaginationStyleType.Large && _style__WEBPACK_IMPORTED_MODULE_14__.paginationInputLargeClassName, border && _style__WEBPACK_IMPORTED_MODULE_14__.paginationInputBorderFontClassName)
      }), h("span", [this.i18n.t.pagination.page])]) : null]);
    }
  }, {
    key: "updateLang",
    value: function updateLang(l) {
      this.i18n.setLanguage(l);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.i18nInjection) {
        this.i18nInjection.addSub(this.updateLang);
        this.i18n.setLanguage(this.i18nInjection.lang);
      }
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.i18nInjection) {
        this.i18nInjection.removeSub(this.updateLang);
      }
    }
  }]);

  return PaginationContainer;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_17__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)()], PaginationContainer.prototype, "page", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)()], PaginationContainer.prototype, "total", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)()], PaginationContainer.prototype, "customTotal", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)()], PaginationContainer.prototype, "totalPages", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)({
  default: 12
})], PaginationContainer.prototype, "size", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)({
  default: function _default() {
    return [12, 24, 48, 96];
  }
})], PaginationContainer.prototype, "sizes", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)({
  default: false
})], PaginationContainer.prototype, "light", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)({
  default: false
})], PaginationContainer.prototype, "border", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)({
  default: 4
})], PaginationContainer.prototype, "pageToShow", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)({
  default: true
})], PaginationContainer.prototype, "showJumper", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)({
  default: true
})], PaginationContainer.prototype, "showTotal", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)({
  default: true
})], PaginationContainer.prototype, "safeJumper", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Prop)({
  default: _types__WEBPACK_IMPORTED_MODULE_15__.PaginationStyleType.Large
})], PaginationContainer.prototype, "styleType", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Emit)('sizeChanged')], PaginationContainer.prototype, "onSizeChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Emit)('pageChanged')], PaginationContainer.prototype, "onPageChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Inject)({
  from: 'i18nInjection',
  default: null
})], PaginationContainer.prototype, "i18nInjection", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Provide)('i18nInjection')], PaginationContainer.prototype, "i18nProvider", void 0);

PaginationContainer = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_16__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_11___default())]
})], PaginationContainer);
/* harmony default export */ __webpack_exports__["default"] = (PaginationContainer);

/***/ }),

/***/ "./src/panel.tsx":
/*!***********************!*\
  !*** ./src/panel.tsx ***!
  \***********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _pagination__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./pagination */ "./src/pagination.tsx");
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./store */ "./src/store/index.ts");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_16__);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};











var Pagination = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(Pagination, _tsx$Component);

  var _super = _createSuper(Pagination);

  function Pagination() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "pageOptions", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "pageConfigs", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "light", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "border", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "showJumper", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "showTotal", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "safeJumper", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "minTotal", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "styleType", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(Pagination, [{
    key: "handlePageSizeChanged",
    value: function handlePageSizeChanged(size) {
      (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.routerPushOrReplace)(this.$router, 'push', {
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          size: (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.clamp)(size, 10).toString(),
          page: '1' // type awesome

        })
      });
    }
  }, {
    key: "handlePageChanged",
    value: function handlePageChanged(page) {
      var query = {
        page: (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.clamp)(page, 1).toString()
      };

      if (!this.$route.query || !this.$route.query.size) {
        query['size'] = this.pageOptions.size;
      }

      (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.routerPushOrReplace)(this.$router, 'push', {
        query: _objectSpread(_objectSpread({}, this.$route.query), query)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var light = this.light,
          border = this.border,
          pageOptions = this.pageOptions,
          pageConfigs = this.pageConfigs,
          handlePageChanged = this.handlePageChanged,
          handlePageSizeChanged = this.handlePageSizeChanged,
          showJumper = this.showJumper,
          showTotal = this.showTotal,
          safeJumper = this.safeJumper,
          styleType = this.styleType;
      var size = pageOptions.size,
          page = pageOptions.page;
      var total = pageConfigs.total,
          sizes = pageConfigs.sizes,
          customTotal = pageConfigs.customTotal;
      return total > this.minTotal ? h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_16__.classes)(_style__WEBPACK_IMPORTED_MODULE_11__.paginationClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('pagination'))
      }, [h(_pagination__WEBPACK_IMPORTED_MODULE_9__["default"], {
        "attrs": {
          "light": light,
          "total": total,
          "customTotal": customTotal,
          "border": border,
          "page": page,
          "size": size,
          "sizes": sizes,
          "showJumper": showJumper,
          "showTotal": showTotal,
          "safeJumper": safeJumper,
          "styleType": styleType
        },
        "on": {
          "pageChanged": handlePageChanged,
          "sizeChanged": handlePageSizeChanged
        }
      })]) : null;
    }
  }]);

  return Pagination;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__.Component);

__decorate([(0,_store__WEBPACK_IMPORTED_MODULE_10__.PaginationGetter)(_store__WEBPACK_IMPORTED_MODULE_10__.Getters.PageOptions)], Pagination.prototype, "pageOptions", void 0);

__decorate([(0,_store__WEBPACK_IMPORTED_MODULE_10__.PaginationGetter)(_store__WEBPACK_IMPORTED_MODULE_10__.Getters.PageConfigs)], Pagination.prototype, "pageConfigs", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: false
})], Pagination.prototype, "light", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: false
})], Pagination.prototype, "border", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], Pagination.prototype, "showJumper", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], Pagination.prototype, "showTotal", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], Pagination.prototype, "safeJumper", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: 0
})], Pagination.prototype, "minTotal", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: _types__WEBPACK_IMPORTED_MODULE_12__.PaginationStyleType.Large
})], Pagination.prototype, "styleType", void 0);

Pagination = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Component], Pagination);
/* harmony default export */ __webpack_exports__["default"] = (Pagination);

/***/ }),

/***/ "./src/store/constants.ts":
/*!********************************!*\
  !*** ./src/store/constants.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Getters": function() { return /* binding */ Getters; },
/* harmony export */   "Mutations": function() { return /* binding */ Mutations; }
/* harmony export */ });
var Getters;

(function (Getters) {
  Getters["PageOptions"] = "PageOptions";
  Getters["PageConfigs"] = "PageConfigs";
  Getters["PaginationOptions"] = "PaginationOptions";
})(Getters || (Getters = {}));

var Mutations;

(function (Mutations) {
  Mutations["PageOptions"] = "UpdatePageOptions";
  Mutations["PageTotal"] = "UpdatePageTotal";
  Mutations["PageCustomTotal"] = "UpdatePageCustomTotal";
  Mutations["PageSizes"] = "UpdatePageSizes";
  Mutations["PageConfigs"] = "UpdatePageConfigs";
  Mutations["Page"] = "UpdatePage";
  Mutations["Size"] = "UpdateSize";
})(Mutations || (Mutations = {}));

/***/ }),

/***/ "./src/store/getters.ts":
/*!******************************!*\
  !*** ./src/store/getters.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getters": function() { return /* binding */ getters; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils */ "./src/utils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./constants */ "./src/store/constants.ts");


var _getters;



var getters = (_getters = {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_getters, _constants__WEBPACK_IMPORTED_MODULE_2__.Getters.PageOptions, function (state) {
  return state.pageOptions;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_getters, _constants__WEBPACK_IMPORTED_MODULE_2__.Getters.PageConfigs, function (state) {
  return state.pageConfigs;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_getters, _constants__WEBPACK_IMPORTED_MODULE_2__.Getters.PaginationOptions, function (state) {
  return (0,_utils__WEBPACK_IMPORTED_MODULE_1__.pageOptionsToPaginationOptions)(state.pageOptions.page, state.pageOptions.size);
}), _getters);

/***/ }),

/***/ "./src/store/index.ts":
/*!****************************!*\
  !*** ./src/store/index.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "moduleName": function() { return /* binding */ moduleName; },
/* harmony export */   "ns": function() { return /* binding */ ns; },
/* harmony export */   "nsHelper": function() { return /* binding */ nsHelper; },
/* harmony export */   "PaginationGetter": function() { return /* binding */ PaginationGetter; },
/* harmony export */   "PaginationMutation": function() { return /* binding */ PaginationMutation; },
/* harmony export */   "Getters": function() { return /* reexport safe */ _constants__WEBPACK_IMPORTED_MODULE_1__.Getters; },
/* harmony export */   "Mutations": function() { return /* reexport safe */ _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations; },
/* harmony export */   "factory": function() { return /* binding */ factory; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constants */ "./src/store/constants.ts");
/* harmony import */ var _getters__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./getters */ "./src/store/getters.ts");
/* harmony import */ var _mutations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mutations */ "./src/store/mutations.ts");
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! vuex */ "vuex");
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var vuex_class__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! vuex-class */ "vuex-class");
/* harmony import */ var vuex_class__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(vuex_class__WEBPACK_IMPORTED_MODULE_5__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var moduleName = 'pagination';
var ns = (0,vuex_class__WEBPACK_IMPORTED_MODULE_5__.namespace)(moduleName);
var nsHelper = (0,vuex__WEBPACK_IMPORTED_MODULE_4__.createNamespacedHelpers)(moduleName);
var PaginationGetter = ns.Getter;
var PaginationMutation = ns.Mutation;

var defaultPageOptions = {
  page: 1,
  size: 10
};
var defaultPageConfigs = {
  total: 0,
  customTotal: null,
  sizes: [10, 20, 30, 100],
  layout: 'total, sizes, prev, pager, next, jumper',
  usePrePageSize: false
};
function factory(store, router) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var pageConfigs = options.pageConfigs || defaultPageConfigs;
  var pageOptions = options.pageOptions || defaultPageOptions;
  var initialStore = {
    pageConfigs: _objectSpread({}, pageConfigs),
    pageOptions: _objectSpread({}, pageOptions)
  };
  store.registerModule(moduleName, {
    getters: _getters__WEBPACK_IMPORTED_MODULE_2__.getters,
    mutations: _mutations__WEBPACK_IMPORTED_MODULE_3__.mutations,
    namespaced: true,
    state: initialStore
  });
  router.afterEach(afterEach);
  var mockInstance = {
    $store: store
  };
  var mutationsHelper = nsHelper.mapMutations([_constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.PageOptions, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.PageConfigs]);
  var getterHelper = nsHelper.mapGetters([_constants__WEBPACK_IMPORTED_MODULE_1__.Getters.PageOptions]);
  var updatePageOptions = mutationsHelper[_constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.PageOptions].bind(mockInstance);
  var updatePageConfigs = mutationsHelper[_constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.PageConfigs].bind(mockInstance);
  var getPageOptions = getterHelper[_constants__WEBPACK_IMPORTED_MODULE_1__.Getters.PageOptions].bind(mockInstance);
  var prePath;

  function afterEach(to) {
    var pStore = getPageOptions();
    var query = to.query;
    var page = Number(query.page) || 1;
    var size = Number(query.size) || (pageConfigs.usePrePageSize ? pStore.size : pageOptions.size);
    updatePageOptions({
      page: page,
      size: size
    });

    if (prePath !== to.path) {
      updatePageConfigs(_objectSpread({}, pageConfigs));
    }

    prePath = to.path;
  }
}

/***/ }),

/***/ "./src/store/mutations.ts":
/*!********************************!*\
  !*** ./src/store/mutations.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mutations": function() { return /* binding */ mutations; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constants */ "./src/store/constants.ts");


var _mutations;


var mutations = (_mutations = {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.PageOptions, function (store, value) {
  store.pageOptions = value;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.PageTotal, function (store, value) {
  store.pageConfigs.total = value;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.PageCustomTotal, function (store, value) {
  store.pageConfigs.customTotal = value;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.PageSizes, function (store, value) {
  store.pageConfigs.sizes = value;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.PageConfigs, function (store, value) {
  store.pageConfigs = value;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.Page, function (store, value) {
  store.pageOptions.page = value;
}), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.Size, function (store, value) {
  store.pageOptions.size = value;
}), _mutations);

/***/ }),

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "paginationClassName": function() { return /* binding */ paginationClassName; },
/* harmony export */   "paginationContainerNormalClassname": function() { return /* binding */ paginationContainerNormalClassname; },
/* harmony export */   "paginationContainerLargeClassname": function() { return /* binding */ paginationContainerLargeClassname; },
/* harmony export */   "paginationTotalClassName": function() { return /* binding */ paginationTotalClassName; },
/* harmony export */   "paginationContainerContentClassName": function() { return /* binding */ paginationContainerContentClassName; },
/* harmony export */   "paginationItemNormalClassName": function() { return /* binding */ paginationItemNormalClassName; },
/* harmony export */   "paginationItemLargeClassName": function() { return /* binding */ paginationItemLargeClassName; },
/* harmony export */   "paginationItemBorderClassName": function() { return /* binding */ paginationItemBorderClassName; },
/* harmony export */   "paginationItemNoBorderClassName": function() { return /* binding */ paginationItemNoBorderClassName; },
/* harmony export */   "paginationDisabledItemClassName": function() { return /* binding */ paginationDisabledItemClassName; },
/* harmony export */   "paginationSelectNormalClassName": function() { return /* binding */ paginationSelectNormalClassName; },
/* harmony export */   "paginationSelectLargeClassName": function() { return /* binding */ paginationSelectLargeClassName; },
/* harmony export */   "paginationJumperClassName": function() { return /* binding */ paginationJumperClassName; },
/* harmony export */   "paginationInputNormalClassName": function() { return /* binding */ paginationInputNormalClassName; },
/* harmony export */   "paginationInputLargeClassName": function() { return /* binding */ paginationInputLargeClassName; },
/* harmony export */   "paginationInputContainerClassName": function() { return /* binding */ paginationInputContainerClassName; },
/* harmony export */   "paginationInputHeightClassName": function() { return /* binding */ paginationInputHeightClassName; },
/* harmony export */   "paginationHighlightClassName": function() { return /* binding */ paginationHighlightClassName; },
/* harmony export */   "paginationHighlightWithoutBorderClassName": function() { return /* binding */ paginationHighlightWithoutBorderClassName; },
/* harmony export */   "paginationQuickPrevButtonClassName": function() { return /* binding */ paginationQuickPrevButtonClassName; },
/* harmony export */   "paginationQuickNextButtonClassName": function() { return /* binding */ paginationQuickNextButtonClassName; },
/* harmony export */   "paginationBorderFontClassName": function() { return /* binding */ paginationBorderFontClassName; },
/* harmony export */   "paginationInputBorderFontClassName": function() { return /* binding */ paginationInputBorderFontClassName; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_4__);





var paginationClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  textAlign: 'center'
});

var paginationContainerGen = function paginationContainerGen(fontSize) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.inlineRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.center, (0,csstips__WEBPACK_IMPORTED_MODULE_2__.horizontallySpaced)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.containerCollision)), {
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.font.toString(),
    fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(fontSize)
  });
};

var paginationContainerNormalClassname = paginationContainerGen(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.fontSize);
var paginationContainerLargeClassname = paginationContainerGen(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.largeFontSize);
var paginationTotalClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.inlineRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.center, (0,csstips__WEBPACK_IMPORTED_MODULE_2__.horizontallySpaced)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.itemCollision)));
var paginationContainerContentClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.inlineRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.center, (0,csstips__WEBPACK_IMPORTED_MODULE_2__.horizontallySpaced)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.itemCollision)));

var paginationItemGen = function paginationItemGen(fontSize, theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.itemTopBottomPadding), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.itemLeftRightPadding)), {
    lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.lineHeight),
    borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.raduisSize),
    cursor: 'pointer',
    outline: 'none',
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.font.toString(),
    fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(fontSize),
    background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.itemBackground.toString(),
    $nest: {
      '&:hover': {
        color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.themeHighlight(theme).toString()
      }
    }
  });
};

var paginationItemNormalClassName = function paginationItemNormalClassName(theme) {
  return paginationItemGen(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.fontSize, theme);
};
var paginationItemLargeClassName = function paginationItemLargeClassName(theme) {
  return paginationItemGen(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.largeFontSize, theme);
};
var paginationItemBorderClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  border: (0,csx__WEBPACK_IMPORTED_MODULE_3__.border)({
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.itemBorder.toString(),
    style: 'solid',
    width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(1)
  }),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.borderFont.toString()
});
var paginationItemNoBorderClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  border: 'none'
});
var paginationDisabledItemClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)('#C0C4CC'),
  cursor: 'not-allowed'
});

var paginationSelectGen = function paginationSelectGen(fontSize) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.width)((0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.selectWidth))), {
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.font.toString(),
    $nest: {
      '& span': {
        fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(fontSize)
      },
      '& li': {
        fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(fontSize)
      }
    }
  });
};

var paginationSelectNormalClassName = paginationSelectGen(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.fontSize);
var paginationSelectLargeClassName = paginationSelectGen(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.largeFontSize);
var paginationJumperClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.inlineRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.center, (0,csstips__WEBPACK_IMPORTED_MODULE_2__.horizontallySpaced)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(8)));

var paginationInputGen = function paginationInputGen(fontSize) {
  var _$nest;

  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    maxWidth: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.inputWidth)),
    $nest: (_$nest = {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_$nest, ".".concat(paginationJumperClassName, " > &"), (0,csstips__WEBPACK_IMPORTED_MODULE_2__.width)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.inputWidth))), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_$nest, ".".concat(paginationJumperClassName, " > & input[type=number]::-webkit-inner-spin-button, ").concat(paginationJumperClassName, " > & input[type=number]::-webkit-outer-spin-button"), {
      '-webkit-appearance': 'none',
      margin: 0
    }), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_$nest, ".".concat(paginationJumperClassName, " > & input[type=number]"), {
      '-moz-appearance': 'textfield'
    }), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_$nest, '& input', {
      textAlign: 'center',
      fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(fontSize)
    }), _$nest)
  });
};

var paginationInputNormalClassName = paginationInputGen(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.fontSize);
var paginationInputLargeClassName = paginationInputGen(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationSizes.largeFontSize);
var paginationInputContainerClassName = function paginationInputContainerClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    $nest: {
      '& input': {
        color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.themeHighlight(theme).toString()
      }
    }
  });
};
var paginationInputHeightClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: {
    '& input': {
      height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(30)
    }
  }
});
var paginationHighlightClassName = function paginationHighlightClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    borderColor: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.themeHighlight(theme).toString(),
    background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.themeHighlight(theme).toString(),
    color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.highlightFont.toString())
  });
};
var paginationHighlightWithoutBorderClassName = function paginationHighlightWithoutBorderClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.themeHighlight(theme).toString())
  });
};
var paginationQuickPrevButtonClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: {
    '&:hover i::before': {
      content: "'\\e6dd'"
    }
  }
});
var paginationQuickNextButtonClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: {
    '&:hover i::before': {
      content: "'\\e6dc'"
    }
  }
});
var paginationBorderFontClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.borderFont.toString()
});
var paginationInputBorderFontClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: {
    '& input': {
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.PaginationColors.borderFont.toString()
    }
  }
});

/***/ }),

/***/ "./src/types.ts":
/*!**********************!*\
  !*** ./src/types.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PaginationStyleType": function() { return /* binding */ PaginationStyleType; }
/* harmony export */ });
var PaginationStyleType;

(function (PaginationStyleType) {
  PaginationStyleType[PaginationStyleType["Normal"] = 0] = "Normal";
  PaginationStyleType[PaginationStyleType["Large"] = 1] = "Large";
})(PaginationStyleType || (PaginationStyleType = {}));

/***/ }),

/***/ "./src/utils.ts":
/*!**********************!*\
  !*** ./src/utils.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pageOptionsToPaginationOptions": function() { return /* binding */ pageOptionsToPaginationOptions; }
/* harmony export */ });
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_0__);

function pageOptionsToPaginationOptions(page, size) {
  return {
    count: size,
    offset: (0,_splat_constant__WEBPACK_IMPORTED_MODULE_0__.clamp)((page - 1) * size, 0)
  };
}

/***/ }),

/***/ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js":
/*!***************************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js ***!
  \***************************************************************************************************************************************************************************/
/***/ (function() {

// dummy js to avoid import error


/***/ }),

/***/ "core-js/modules/esnext.global-this.js":
/*!********************************************************!*\
  !*** external "core-js/modules/esnext.global-this.js" ***!
  \********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__;

/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/input":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/input","commonjs2":"@splat/input"} ***!
  \***********************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_input__;

/***/ }),

/***/ "@splat/select":
/*!*************************************************************************!*\
  !*** external {"commonjs":"@splat/select","commonjs2":"@splat/select"} ***!
  \*************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_select__;

/***/ }),

/***/ "@splat/theme":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/theme","commonjs2":"@splat/theme"} ***!
  \***********************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_theme__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "vuex":
/*!*******************************************************!*\
  !*** external {"commonjs":"vuex","commonjs2":"vuex"} ***!
  \*******************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vuex__;

/***/ }),

/***/ "vuex-class":
/*!*******************************************************************!*\
  !*** external {"commonjs":"vuex-class","commonjs2":"vuex-class"} ***!
  \*******************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vuex_class__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PaginationStyleType": function() { return /* reexport safe */ _types__WEBPACK_IMPORTED_MODULE_1__.PaginationStyleType; },
/* harmony export */   "Getters": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.Getters; },
/* harmony export */   "Mutations": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.Mutations; },
/* harmony export */   "PaginationGetter": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.PaginationGetter; },
/* harmony export */   "PaginationMutation": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.PaginationMutation; },
/* harmony export */   "factory": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.factory; },
/* harmony export */   "moduleName": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.moduleName; },
/* harmony export */   "ns": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.ns; },
/* harmony export */   "nsHelper": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_2__.nsHelper; },
/* harmony export */   "pageOptionsToPaginationOptions": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_3__.pageOptionsToPaginationOptions; },
/* harmony export */   "Pagination": function() { return /* reexport safe */ _pagination__WEBPACK_IMPORTED_MODULE_4__["default"]; },
/* harmony export */   "Item": function() { return /* reexport safe */ _item__WEBPACK_IMPORTED_MODULE_5__["default"]; }
/* harmony export */ });
/* harmony import */ var _panel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./panel */ "./src/panel.tsx");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./store */ "./src/store/index.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils */ "./src/utils.ts");
/* harmony import */ var _pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./pagination */ "./src/pagination.tsx");
/* harmony import */ var _item__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./item */ "./src/item.tsx");






/* harmony default export */ __webpack_exports__["default"] = (_panel__WEBPACK_IMPORTED_MODULE_0__["default"]);
}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map